import './CoralTeacherResourcesCards.scss'

import { useIsWindowBiggerThan } from '@bob/library'
import { CoralHeading } from '@websrc/App/Components/CoralHeading/CoralHeading'
import { CoralMasterCardVisuals } from '@websrc/DataMappers/mapCoralMasterCard'
import { mapCoralWebTeacherResourcesCards } from '@websrc/DataMappers/mapSpot'
import React, { FC, useMemo } from 'react'

import { CoralMasterCard } from '../../../coral-library/cards/Coral/ContentCard/CoralMasterCard'

type CoralTeacherResourcesCardsProps = ReturnType<typeof mapCoralWebTeacherResourcesCards>

const smVisuals: CoralMasterCardVisuals = {
  contentBadgeColor: 'teal-pale',
  subheadSize: 'body-md',
  headlineSize: 'h2-sm',
  bodySize: 'body-lg',
  contentContainerColor: 'off-white',
  contentPadding: '3xl',
  paddingHeadline: 'sm',
  imageOrientation: 'top',
  paddingBody: 'lg',
  buttonIcon: 'upRightArrow',
  buttonSize: 'md',
  buttonType: ['fill', 'outline'],
  radius: 4,
}
const lgVisuals: CoralMasterCardVisuals = {
  contentBadgeColor: 'teal-pale',
  subheadSize: 'body-lg',
  headlineSize: 'h2-md',
  bodySize: 'body-lg',
  contentContainerColor: 'off-white',
  contentPadding: '3xl',
  paddingHeadline: 'sm',
  imageOrientation: 'top',
  paddingBody: 'lg',
  buttonIcon: 'upRightArrow',
  buttonType: ['fill', 'outline'],
  buttonSize: 'lg',
  radius: 4,
}
export const CoralTeacherResourcesCards: FC<CoralTeacherResourcesCardsProps> = (props) => {
  const isDesktop = useIsWindowBiggerThan(1079)

  const visuals: CoralMasterCardVisuals = useMemo(
    () => (isDesktop ? lgVisuals : smVisuals),
    [isDesktop]
  )
  return (
    <div className={'category-coral-spot override-top-padding'}>
      <div className={'coral-teacher-resources-cards'}>
        <CoralHeading header={props.header} />
        <div className={'coral-teacher-resources-cards__list'}>
          {props.cards.map((card, index) => {
            const cardVisuals = index === 0 ? { ...visuals, buttonIcon: undefined } : visuals
            card.badgeColor = 'blue-pale'
            return (
              <div className={'coral-teacher-resources-cards__item'} key={index}>
                <CoralMasterCard {...card} visuals={cardVisuals} />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
